module.exports = __webpack_public_path__ + "static/media/bell.5fb51c0c.svg";